module.exports = __webpack_public_path__ + "img/magento-migration@2x.1497cd17.jpg";